import React from 'react';
import clsx from 'clsx';
import { formatPriceWithEuro, truncate } from '../../utils/StringUtils';

const MidiDealCartRecapHeader = ({ originalPrice, dealPrice, title = "Midi Deal", description = "1 principal, 1 snack et 1 boisson" }) => (
    <div className="flex justify-between items-start px-4 mb-3">
        <div className="flex flex-col">
            <span className="geomanistBook text-[16px] text-[#0E0B26]">{title}</span>
            <span className="geomanistRegular text-[13px] text-gray-800">{description}</span>
        </div>
        <div className="flex items-center gap-2">
            <span className="geomanistMedium text-[16px] text-zinc-400 line-through decoration-gray-400">
                {formatPriceWithEuro(originalPrice)}
            </span>
            <span className="relative geomanistBold text-[22px]" style={{ letterSpacing: "1px" }}>
                <span
                    className="absolute inset-0"
                    style={{
                        WebkitTextStroke: "3px #C89825",
                        color: "transparent"
                    }}
                >{formatPriceWithEuro(dealPrice)}</span>
                <span
                    style={{
                        background: "linear-gradient(107.64deg, #f3d349ff 64.66%, #F19F10 100.98%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        position: "relative",
                        filter: "drop-shadow(1px 2px 0px #C89825)"
                    }}
                >{formatPriceWithEuro(dealPrice)}</span>
            </span>
        </div>
    </div>
);

const MidiDealCartRecapItem = ({ item, index }) => (
    <div className={clsx(
        "flex rounded-none items-center justify-between p-6 bg-[#FFF9EA]",
        {
            "border border-t border-b-0 border-l-0 border-r-0 border-[#51430a18]": index !== 0
        }
    )}>
        <div className="flex items-center gap-3">
            <div className="w-[50px] h-[50px] bg-white rounded-lg flex items-center justify-center overflow-hidden">
                <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-contain"
                />
            </div>
            <span className="geomanistBook text-[14px] text-[#0E0B26]">
                {truncate(item.title, 20)}
            </span>
        </div>

        <div className="flex flex-col items-end">
            <span className="geomanistRegular text-[13px] text-gray-600">Qté: {item.qty || 1}</span>
            <span className="geomanistBold text-[14px] text-[#0E0B26]">
                {formatPriceWithEuro(item.price || item.originalPrice)}
            </span>
        </div>
    </div>
);

const MidiDealCartRecap = ({ midiDeal }) => {
    if (!midiDeal) return null;

  const { dealPrice, originalPrice, items } = midiDeal;

    return (
        <div className="w-full bg-[#FFF9EA] rounded-xl pt-4 mb-4 overflow-hidden">
            <MidiDealCartRecapHeader originalPrice={originalPrice} dealPrice={dealPrice} />

            <div className="flex flex-col">
                {items.map((item, index) => (
                    <MidiDealCartRecapItem key={item.id || index} item={item} index={index} />
                ))}
            </div>
        </div>
    );
};

export default MidiDealCartRecap;
